import state from './moduleWhatsappProfileState'
import actions from './moduleWhatsappProfileActions'
import getters from './moduleWhatsappProfileGetters'
import mutations from './moduleWhatsappProfileMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
